export default __webpack_public_path__ + "static/media/logo.d006b7b3.png";